import { render } from "./CoffeeTypeIcon.vue?vue&type=template&id=2b4bb6d3"
import script from "./CoffeeTypeIcon.vue?vue&type=script&lang=js"
export * from "./CoffeeTypeIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__